module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "container flex",
    style: (_vm.style)
  }, [_c('span', {
    staticClass: "mr-20"
  }, [_vm._v(" " + _vm._s(Math.round((_vm.progress / _vm.max) * 100)) + "%")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c83db38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/progressBar.vue
// module id = 248
// module chunks = 0 1 2 3 5 6